jQuery(document).ready (function () {

  var carousel_grid_four = jQuery('.carousel--grid-four');
  if (carousel_grid_four != null) {
    carousel_grid_four.owlCarousel ({
      loop: false,
      dots: false,
      lazyLoad: true,
      nav: true,
      navText: [
      ],
      items: 4,
      responsive: {
        0: { items: 1 },
        480: { items: 1 },
        768: { items: 1 },
        961: { margin: 7.5, autoWidth: true, items: 2 },
        1920: { margin: 7.5, items: 4 },
      },
    });
  }

  var carousel_grid_one = jQuery('.carousel--grid-one');
  if (carousel_grid_one != null) {
    carousel_grid_one.owlCarousel ({
      loop: false,
      dots: false,
      lazyLoad: true,
      nav: true,
      navText: [
      ],
      items: 1,
    });
  }

  if (jQuery('.fancybox').length > 0) {
    jQuery('.fancybox').fancybox ({
      openEffect: 'none',
      closeEffect: 'none',
      fitToView: false,
      aspectRatio: false,
      width: '100%',
      height: '100%',
      autoDimensions: false,
      maxWidth: '100%',
      closeClick: false,
      padding: 0,
      helpers: {
        title: { type: 'inside' },
        overlay: {
          locked: false,
        },
      },
      afterLoad: function () {
        this.title =
          this.title + ' ' + jQuery(this.element).find ('img').attr ('alt');
      },
    });
  }

});
